export default __webpack_public_path__ + "selenium.4b88e67e.png";